import React, { Component } from 'react';

export default class extends Component {
  handleClick = (v) => {
    this.props.onSelect(v);
  }

  render = () => {
    let loadMore;

    if (this.props.suggestions.length > 0 && this.props.loadMore) {
      const loadMoreClassName = (this.props.highlighted === -1) ? 'suggestions-button-load-more active' : 'suggestions-button-load-more';
      loadMore = <button className={loadMoreClassName} onClick={this.props.onLoadMore}>...</button>
    }

    return <section className="suggestions" style={this.props.style}>
      {
        this.props.suggestions
        .map((v, k) => {
          const optionClassName = (this.props.highlighted === k) ? 'suggestions-option highlight' : 'suggestions-option';
          return  <section key={k} className={optionClassName} onClick={() => this.handleClick(v)}>{v}</section>
        })
      }
      { loadMore }
    </section>
  }
}


// WEBPACK FOOTER //
// ./src/components/Suggestions.js